export const adminInvoicePresetsApi = {

    getAll () {
        return axios.get(`/api/admin/invoice_preset`)
    },

}
